export default __webpack_public_path__ + "static/BuyCarbon-0d83d245064cf96ad459c3170676483e.png";